import { mapDTO } from '@twistezo/ts-dto-mapper'

import { AdUnitRefresherDTO } from 'features/inventory/api/types/adUnitRefresherDTO'
import { AdUnitRefresher } from 'features/inventory/types/adUnitRefresher'
import { floatPercentFromDTO } from 'utils/number'

type From = AdUnitRefresherDTO
type To = AdUnitRefresher

export const adUnitRefresherFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((adUnitRefresherDTO: From): To => {
    const {
      adUnitId,
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold,
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval,
      externalAdUnitPath,
      id,
      mobileAdThreshold,
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval,
      refresherEnabled,
      sendRefreshRequestToExternalAdUnitEnabled,
      updatedAt,
    } = adUnitRefresherDTO

    return {
      adUnitId,
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold: floatPercentFromDTO(desktopAdThreshold),
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval: desktopRefreshInterval / 1000,
      id,
      mobileAdThreshold: floatPercentFromDTO(mobileAdThreshold),
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval: mobileRefreshInterval / 1000,
      refresherEnabled,
      sendRefreshRequestToExternalAdUnitEnabled,
      targetAdUnitPath: externalAdUnitPath ?? undefined,
      updatedAt: new Date(updatedAt),
    }
  })
